export function GetInTouch() {
  return <div className=" mt-36">Get In Touch</div>;
}
